import { Component, inject, Signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Log, Message, ToolJobLogs } from '../../models/tool.models';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-job-logs-dial',
  imports: [NgClass, MatIcon, MatButton],
  templateUrl: './job-logs-dial.component.html',
  styleUrl: './job-logs-dial.component.scss',
})
export class JobLogsDialComponent {
  /** Inject services. */
  private readonly dialogRef = inject<MatDialogRef<JobLogsDialComponent>>(MatDialogRef);
  private readonly data = inject<Signal<ToolJobLogs | Log> | ToolJobLogs | Log>(MAT_DIALOG_DATA);
  private readonly clipboard = inject(Clipboard);
  private readonly snackBar = inject(MatSnackBar);

  logs: Message[];
  jobId: number;

  constructor() {
    const data = typeof this.data === 'function' ? this.data() : this.data;
    if ('toolJobId' in data) {
      this.logs = data.logs.map(message => ({
        message,
        timestamp: '',
      }));
      this.jobId = data.toolJobId;
    } else {
      this.logs = data.log;
      this.jobId = -1;
    }
  }

  onCopyLogs() {
    const logText = this.logs.join('\n');
    this.clipboard.copy(logText);
    this.snackBar.open('Logs copied!', 'Close', { duration: 1500 });
  }

  onClose() {
    this.dialogRef.close();
  }
}
